var noop = function () { return null; };
var promiseNoop = function () { return Promise.resolve(); };
export { noop, promiseNoop };
//# sourceMappingURL=noop.js.map